import React from 'react';
import { Download, ExternalLink, FileImage, Loader2, Trash2 } from 'lucide-react';

const DrawingFilesList = ({
  groupedDrawings,
  deletingDrawingId,
  onDeleteDrawing
}) => (
  <div className="flex max-h-[60vh] flex-col gap-4 overflow-y-auto pr-1">
    {groupedDrawings.map((group) => (
      <div key={group.type}>
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
          {group.type}
        </p>
        <div className="flex flex-col gap-2">
          {group.items.map((drawing) => {
            const isDeleting = deletingDrawingId === drawing.id;
            const canDelete = Boolean(drawing.drawingType && drawing.fileKey);

            return (
              <div
                key={drawing.id}
                className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2.5">
                <FileImage className="h-5 w-5 shrink-0 text-[#2B5C66]" />
                <div className="min-w-0 flex-1">
                  <p
                    className="truncate text-sm font-medium text-gray-800"
                    title={drawing.name}>
                    {drawing.name}
                  </p>
                </div>
                <div className="flex shrink-0 items-center gap-1">
                  {drawing.url ? (
                    <>
                      <a
                        href={drawing.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50"
                        aria-label={`View ${drawing.name}`}
                        title="View">
                        <ExternalLink size={16} />
                      </a>
                      <a
                        href={drawing.url}
                        download={drawing.name}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50"
                        aria-label={`Download ${drawing.name}`}
                        title="Download">
                        <Download size={16} />
                      </a>
                    </>
                  ) : (
                    <span className="px-1 text-xs text-gray-400">No link</span>
                  )}
                  {onDeleteDrawing && canDelete ? (
                    <button
                      type="button"
                      onClick={() => onDeleteDrawing(drawing)}
                      disabled={Boolean(deletingDrawingId)}
                      className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-600 hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600 disabled:cursor-not-allowed disabled:opacity-50"
                      aria-label={`Delete ${drawing.name}`}
                      title="Delete">
                      {isDeleting ? (
                        <Loader2 size={16} className="animate-spin" />
                      ) : (
                        <Trash2 size={16} />
                      )}
                    </button>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

export default DrawingFilesList;
